import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '@/lib/http-client';

const endpoint = '/homepage';
const endpointProduct = '/product';

export default {
	getPublicProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpointProduct}/public?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getWishlistProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpointProduct}/wishlist?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getSupplierDetail(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/supplier?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getPublicSections(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/section?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getPublicBanners(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/banner?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getPublicTopProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/top_product?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getOtherProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpointProduct}/other?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getLimitedStockProductIds(cb, errorCb) {
		const url = `${endpointProduct}/limited-stock`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getRangeStockCheckedProducts(cb, errorCb) {
		const url = `${endpointProduct}/range-stock`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getStockCheckedProducts(cb, errorCb) {
		const url = `${endpointProduct}/stock-checked`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin -- Get List Banner
	getBanner(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/admin/banner?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Admin - Create Banner
	createBanner(params, cb, errorCb) {
		const url = `${endpoint}/admin/banner`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Delete Banner
	deleteBanner(id, cb, errorCb) {
		const url = `${endpoint}/admin/banner/${id}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Admin -- Get List Section
	getSection(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/admin/section?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Admin - Update/Create Section
	createOrUpdateSection(params, cb, errorCb) {
		const url = `${endpoint}/admin/section`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get List of All Categories
	 *
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	getAllCategories(cb, errorCb) {
		const url = `${endpoint}/categories`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Admin - Change Banner Position
	changeOrderBanner(params, cb, errorCb) {
		const url = `${endpoint}/admin/banner/order`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Ask Stock
	askStock(params, cb, errorCb) {
		const url = `${endpoint}/ask-stock`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getDataPopupInformation(params, cb, errorCb) {
		const url = `${endpoint}/popup-information`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	}
	,
};
